/* tslint:disable */
/* eslint-disable */
/**
 * goal-wear
 * API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PatchedSettings } from '../models';
// @ts-ignore
import type { Settings } from '../models';
// @ts-ignore
import type { TwilioSettingsRequest } from '../models';
// @ts-ignore
import type { TwilioSettingsResponse } from '../models';
/**
 * SettingsApi - axios parameter creator
 * @export
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Settings} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsCreate: async (settings: Settings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('mainConfigurationsCreate', 'settings', settings)
            const localVarPath = `/api/main/configurations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsDestroy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainConfigurationsDestroy', 'id', id)
            const localVarPath = `/api/main/configurations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/configurations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {PatchedSettings} [patchedSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsPartialUpdate: async (id: number, patchedSettings?: PatchedSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainConfigurationsPartialUpdate', 'id', id)
            const localVarPath = `/api/main/configurations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainConfigurationsRetrieve', 'id', id)
            const localVarPath = `/api/main/configurations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Obtener configuración Twilio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsTwilioRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/configurations/twilio/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actualizar configuración Twilio
         * @param {TwilioSettingsRequest} [twilioSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsTwilioUpdate: async (twilioSettingsRequest?: TwilioSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/main/configurations/twilio/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twilioSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {Settings} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsUpdate: async (id: number, settings: Settings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mainConfigurationsUpdate', 'id', id)
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('mainConfigurationsUpdate', 'settings', settings)
            const localVarPath = `/api/main/configurations/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsApi - functional programming interface
 * @export
 */
export const SettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Settings} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsCreate(settings: Settings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsCreate(settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsDestroy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Settings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {PatchedSettings} [patchedSettings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsPartialUpdate(id: number, patchedSettings?: PatchedSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsPartialUpdate(id, patchedSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Obtener configuración Twilio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsTwilioRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwilioSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsTwilioRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsTwilioRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actualizar configuración Twilio
         * @param {TwilioSettingsRequest} [twilioSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsTwilioUpdate(twilioSettingsRequest?: TwilioSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TwilioSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsTwilioUpdate(twilioSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsTwilioUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id A unique integer value identifying this Configuración.
         * @param {Settings} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mainConfigurationsUpdate(id: number, settings: Settings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mainConfigurationsUpdate(id, settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsApi.mainConfigurationsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsApi - factory interface
 * @export
 */
export const SettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {SettingsApiMainConfigurationsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsCreate(requestParameters: SettingsApiMainConfigurationsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Settings> {
            return localVarFp.mainConfigurationsCreate(requestParameters.settings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiMainConfigurationsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsDestroy(requestParameters: SettingsApiMainConfigurationsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mainConfigurationsDestroy(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Settings>> {
            return localVarFp.mainConfigurationsList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiMainConfigurationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsPartialUpdate(requestParameters: SettingsApiMainConfigurationsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Settings> {
            return localVarFp.mainConfigurationsPartialUpdate(requestParameters.id, requestParameters.patchedSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiMainConfigurationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsRetrieve(requestParameters: SettingsApiMainConfigurationsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Settings> {
            return localVarFp.mainConfigurationsRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtener configuración Twilio
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsTwilioRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<TwilioSettingsResponse> {
            return localVarFp.mainConfigurationsTwilioRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actualizar configuración Twilio
         * @param {SettingsApiMainConfigurationsTwilioUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsTwilioUpdate(requestParameters: SettingsApiMainConfigurationsTwilioUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TwilioSettingsResponse> {
            return localVarFp.mainConfigurationsTwilioUpdate(requestParameters.twilioSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingsApiMainConfigurationsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mainConfigurationsUpdate(requestParameters: SettingsApiMainConfigurationsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Settings> {
            return localVarFp.mainConfigurationsUpdate(requestParameters.id, requestParameters.settings, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for mainConfigurationsCreate operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsCreateRequest
 */
export interface SettingsApiMainConfigurationsCreateRequest {
    /**
     * 
     * @type {Settings}
     * @memberof SettingsApiMainConfigurationsCreate
     */
    readonly settings: Settings
}

/**
 * Request parameters for mainConfigurationsDestroy operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsDestroyRequest
 */
export interface SettingsApiMainConfigurationsDestroyRequest {
    /**
     * A unique integer value identifying this Configuración.
     * @type {number}
     * @memberof SettingsApiMainConfigurationsDestroy
     */
    readonly id: number
}

/**
 * Request parameters for mainConfigurationsPartialUpdate operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsPartialUpdateRequest
 */
export interface SettingsApiMainConfigurationsPartialUpdateRequest {
    /**
     * A unique integer value identifying this Configuración.
     * @type {number}
     * @memberof SettingsApiMainConfigurationsPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedSettings}
     * @memberof SettingsApiMainConfigurationsPartialUpdate
     */
    readonly patchedSettings?: PatchedSettings
}

/**
 * Request parameters for mainConfigurationsRetrieve operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsRetrieveRequest
 */
export interface SettingsApiMainConfigurationsRetrieveRequest {
    /**
     * A unique integer value identifying this Configuración.
     * @type {number}
     * @memberof SettingsApiMainConfigurationsRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for mainConfigurationsTwilioUpdate operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsTwilioUpdateRequest
 */
export interface SettingsApiMainConfigurationsTwilioUpdateRequest {
    /**
     * 
     * @type {TwilioSettingsRequest}
     * @memberof SettingsApiMainConfigurationsTwilioUpdate
     */
    readonly twilioSettingsRequest?: TwilioSettingsRequest
}

/**
 * Request parameters for mainConfigurationsUpdate operation in SettingsApi.
 * @export
 * @interface SettingsApiMainConfigurationsUpdateRequest
 */
export interface SettingsApiMainConfigurationsUpdateRequest {
    /**
     * A unique integer value identifying this Configuración.
     * @type {number}
     * @memberof SettingsApiMainConfigurationsUpdate
     */
    readonly id: number

    /**
     * 
     * @type {Settings}
     * @memberof SettingsApiMainConfigurationsUpdate
     */
    readonly settings: Settings
}

/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */
export class SettingsApi extends BaseAPI {
    /**
     * 
     * @param {SettingsApiMainConfigurationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsCreate(requestParameters: SettingsApiMainConfigurationsCreateRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsCreate(requestParameters.settings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiMainConfigurationsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsDestroy(requestParameters: SettingsApiMainConfigurationsDestroyRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsDestroy(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsList(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiMainConfigurationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsPartialUpdate(requestParameters: SettingsApiMainConfigurationsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsPartialUpdate(requestParameters.id, requestParameters.patchedSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiMainConfigurationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsRetrieve(requestParameters: SettingsApiMainConfigurationsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtener configuración Twilio
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsTwilioRetrieve(options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsTwilioRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actualizar configuración Twilio
     * @param {SettingsApiMainConfigurationsTwilioUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsTwilioUpdate(requestParameters: SettingsApiMainConfigurationsTwilioUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsTwilioUpdate(requestParameters.twilioSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingsApiMainConfigurationsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsApi
     */
    public mainConfigurationsUpdate(requestParameters: SettingsApiMainConfigurationsUpdateRequest, options?: RawAxiosRequestConfig) {
        return SettingsApiFp(this.configuration).mainConfigurationsUpdate(requestParameters.id, requestParameters.settings, options).then((request) => request(this.axios, this.basePath));
    }
}

